import React, { Component } from 'react';
import { withRouter } from 'react-router';
import queryString from 'query-string';
import Slider from './types/turnover-sek';
import Chains from './types/chains';
import Geography from './types/geography';
import Facet from './facet';
import Assortments from './types/assortment';
import OtherInformation from './types/otherinformation';
import classNames from 'classnames';
import Types from './types/type';
import Units from './types/units';

class Facets extends Component {
    constructor(props) {
        super(props);
        this.allFacets = [];
        this.turnoverClass = [{
            label: '1',
            min: 1,
            max: 499
        }, {
            label: '2',
            min: 500,
            max: 999
        }, {
            label: '3',
            min: 1000,
            max: 1999
        }, {
            label: '4',
            min: 2000,
            max: 2999
        }, {
            label: '5',
            min: 3000,
            max: 3999
        }, {
            label: '6',
            min: 4000,
            max: 4999
        }, {
            label: '7',
            min: 5000,
            max: 5999
        }, {
            label: '8',
            min: 6000,
            max: 7999
        }, {
            label: '9',
            min: 8000,
            max: 9999
        }, {
            label: '10',
            min: 10000,
            max: 14999
        }, {
            label: '11',
            min: 15000,
            max: 19999
        }, {
            label: '12',
            min: 20000,
            max: 24999
        }, {
            label: '13',
            min: 25000,
            max: 29999
        }, {
            label: '14',
            min: 30000,
            max: 39999
        }, {
            label: '15',
            min: 40000,
            max: 49999
        }, {
            label: '16',
            min: 50000,
            max: 59999
        }, {
            label: '17',
            min: 60000,
            max: 74999
        }, {
            label: '18',
            min: 75000,
            max: 99999
        }, {
            label: '19',
            min: 100000,
            max: 1500000
        }];

        this.turnoverMeal = [{
            label: '1',
            min: 1,
            max: 24
        }, {
            label: '2',
            min: 25,
            max: 49
        }, {
            label: '3',
            min: 50,
            max: 99
        }, {
            label: '4',
            min: 100,
            max: 149
        }, {
            label: '5',
            min: 150,
            max: 199
        }, {
            label: '6',
            min: 200,
            max: 299
        }, {
            label: '7',
            min: 300,
            max: 399
        }, {
            label: '8',
            min: 400,
            max: 499
        }, {
            label: '9',
            min: 500,
            max: 599
        }, {
            label: '10',
            min: 600,
            max: 699
        }, {
            label: '11',
            min: 700,
            max: 799
        }, {
            label: '12',
            min: 800,
            max: 899
        }, {
            label: '13',
            min: 900,
            max: 999
        }, {
            label: '14',
            min: 1000,
            max: 1499
        }, {
            label: '15',
            min: 1500,
            max: 1999
        }, {
            label: '16',
            min: 2000,
            max: 2499
        }, {
            label: '17',
            min: 2500,
            max: 99999
        }];
    }

    closeAllFacets() {
        this.allFacets.forEach(facet => {
            if (facet.state.isOpen) {
                facet.close()
            }
        });
    }

    checkIfAnyModalIsOpen() {
        let isOpen = false;
        let isTakeOver = false;
        this.allFacets.forEach(facet => {
            if (facet.state.isOpen) {
                isOpen = true;

                if (facet.props.modifiers && facet.props.modifiers['filters__control--is-takeover']) {
                    isTakeOver = true;
                }
            }
        });

        if (isOpen) {
            document.body.classList.add('modal-open');
            if (isTakeOver) {
                document.body.classList.add('modal-open--takeover');
            }
        } else {
            document.body.classList.remove('modal-open');
            document.body.classList.remove('modal-open--takeover');
        }
    }

    addFacet(facet) {
        this.allFacets.push(facet);
    }

    numOfFacetsApplied(facetName) {
        const { location } = this.props;
        const qs = queryString.parse(location.search);
        if (qs && qs[facetName]) {
            return typeof qs[facetName] === 'string' ? 1 : qs[facetName].length;
        }

        return 0;
    }

    getFacetValue(facetName) {
        const { location } = this.props;
        const qs = queryString.parse(location.search);
        if (qs && qs[facetName]) {
            return qs[facetName];
        }

        return null;
    }

    getSearchText() {
        const { location } = this.props;
        const qs = queryString.parse(location.search);
        if (qs && qs.searchText) {
            return qs.searchText;
        }

        return null;
    }

    render() {

        const turoverClassFacets = this.props.search && this.props.search.facets && this.props.search.facets.filter(f => f.key === 'turnoverclass');
        const turoverMealClassFacets = this.props.search && this.props.search.facets && this.props.search.facets.filter(f => f.key === 'turnovermealclass');


        return (
            <div className={classNames({
                'filters__controls': true,
                'filters__controls--is-loading': this.props.isLoading
            })}>
                <input type="hidden" name="searchText" value={this.getSearchText()} />
                {this.props.useTurnover &&
                    <Facet text={this.getFacetValue('turnover') ? `${this.getFacetValue('turnover')} KSEK/år` : 'Omsättning'} 
                        addFacet={(facet) => this.addFacet(facet)} 
                        turnoverclass={turoverClassFacets}
                        closeAllFacets={() => this.closeAllFacets()} 
                        checkIfAnyModalIsOpen={() => this.checkIfAnyModalIsOpen()}
                        submitForm={this.props.submitForm}
                        modifiers={this.getFacetValue('turnover') && {
                            'filters__control--is-active': true
                            }}>
                            <Slider caption="KSEK/år" 
                                    param="turnover" 
                                    turnoverClasses={this.turnoverClass} />
                    </Facet>
                }
                
                {this.props.useTurnoverMeal &&
                    <Facet text={this.getFacetValue('turnovermeal') ? `${this.getFacetValue('turnovermeal')} portioner/dag` : 'Portioner'}
                        addFacet={(facet) => this.addFacet(facet)} 
                        turnoverclass={turoverMealClassFacets}
                        closeAllFacets={() => this.closeAllFacets()} 
                        checkIfAnyModalIsOpen={() => this.checkIfAnyModalIsOpen()}
                        submitForm={this.props.submitForm}
                        modifiers={this.getFacetValue('turnovermeal') && {
                            'filters__control--is-active': true
                            }}>
                        <Slider caption="Portioner/dag" 
                                param="turnovermeal" 
                                turnoverClasses={this.turnoverMeal}/>
                    </Facet>
                }
                
                {this.props.useType &&
                    <Facet text={this.numOfFacetsApplied('typename') ? `${this.numOfFacetsApplied('typename')} typ${this.numOfFacetsApplied('typename') > 1 ? 'er' : ''}` : 'Typ'} 
                            chainGroups={this.props.search && this.props.search.facets && this.props.search.facets.filter(f => f.key === 'typegroupname')}
                            groupParam="typegroupname"
                            childParam="typename"
                            modalModifiers={{ 'modal--chains': true }} 
                            addFacet={(facet) => this.addFacet(facet)} 
                            closeAllFacets={() => this.closeAllFacets()}
                            checkIfAnyModalIsOpen={() => this.checkIfAnyModalIsOpen()}
                            submitForm={this.props.submitForm}
                            form={this.props.form}
                            modifiers={this.numOfFacetsApplied('typename') && {
                            'filters__control--is-active': true
                            }}>
                        <Types />
                    </Facet>
                }

                {this.props.useRegion &&
                    <Facet text={(this.numOfFacetsApplied('aregionname') ||  this.numOfFacetsApplied('municipalityname')) ? `Geografi • ${(this.numOfFacetsApplied('aregionname') || 0) + (this.numOfFacetsApplied('municipalityname') || 0)} val` : 'Geografi'} 
                           aregion={this.props.search && this.props.search.facets && this.props.search.facets.filter(f => f.key === 'aregionname')}
                           municipality={this.props.search && this.props.search.facets && this.props.search.facets.filter(f => f.key === 'municipalityname')}
                           visitingcity={this.props.search && this.props.search.facets && this.props.search.facets.filter(f => f.key === 'visitingcity')}
                           allMunicipality={this.props.search && this.props.search.facets && this.props.search.facets.filter(f => f.key === 'municipalityname')}
                           modalModifiers={{ 'modal--geography': true }} 
                           addFacet={(facet) => this.addFacet(facet)} 
                           closeAllFacets={() => this.closeAllFacets()}
                           checkIfAnyModalIsOpen={() => this.checkIfAnyModalIsOpen()}
                           submitForm={this.props.submitForm} 
                           form={this.props.form}
                           modifiers={{
                            'filters__control--is-takeover': true,
                            'filters__control--is-active': (this.numOfFacetsApplied('aregionname') ||  this.numOfFacetsApplied('municipalityname'))
                           }}>
                        <Geography />
                    </Facet>
                }
                
                {this.props.useChainname &&
                    <Facet text={this.numOfFacetsApplied('chainname') ? `${this.numOfFacetsApplied('chainname')} kedj${this.numOfFacetsApplied('chainname') > 1 ? 'or' : 'a'}` : 'Kedja'} 
                           chainGroups={this.props.search && this.props.search.facets && this.props.search.facets.filter(f => f.key === 'chaingroup')}
                           groupParam="chaingroup"
                           childParam="chainname"
                           modalModifiers={{ 'modal--chains': true }} 
                           addFacet={(facet) => this.addFacet(facet)} 
                           closeAllFacets={() => this.closeAllFacets()}
                           checkIfAnyModalIsOpen={() => this.checkIfAnyModalIsOpen()}
                           submitForm={this.props.submitForm}
                           form={this.props.form}
                           modifiers={this.numOfFacetsApplied('chainname') && {
                            'filters__control--is-active': true
                            }}>
                        <Chains />
                    </Facet>
                }

                {this.props.useArea &&
                    <Facet text={this.getFacetValue('turnover') ? `${this.getFacetValue('turnover')} m2` : 'Säljyta'} 
                        addFacet={(facet) => this.addFacet(facet)} 
                        turnoverclass={turoverClassFacets}
                        closeAllFacets={() => this.closeAllFacets()} 
                        checkIfAnyModalIsOpen={() => this.checkIfAnyModalIsOpen()}
                        submitForm={this.props.submitForm}
                        modifiers={this.getFacetValue('turnover') && {
                            'filters__control--is-active': true
                            }}>
                            <Slider caption="Säljyta m2" 
                                    param="turnover" 
                                    turnoverClasses={this.turnoverClass} />
                    </Facet>
                }

                {this.props.useIndividualChains &&
                    <Facet text={this.numOfFacetsApplied('chainname') ? `${this.numOfFacetsApplied('chainname')} kedj${this.numOfFacetsApplied('chainname') > 1 ? 'or' : 'a'}` : 'Filtrera enskilda butiker'} 
                           addFacet={(facet) => this.addFacet(facet)} 
                           closeAllFacets={() => this.closeAllFacets()}
                           checkIfAnyModalIsOpen={() => this.checkIfAnyModalIsOpen()}
                           submitForm={this.props.submitForm}
                           form={this.props.form}
                           modifiers={this.numOfFacetsApplied('chainname') && {
                            'filters__control--is-active': true
                            }}>
                        <Units />
                    </Facet>
                }
                
                {this.props.useWholesalename &&
                    <Facet text={this.numOfFacetsApplied('wholesalename') ? `${this.numOfFacetsApplied('wholesalename')} grossist${this.numOfFacetsApplied('wholesalename') > 1 ? 'er' : ''}` : 'Grossist'} 
                        chainGroups={this.props.search && this.props.search.facets && this.props.search.facets.filter(f => f.key === 'wholesalegroupname')}
                        groupParam="wholesalegroupname"
                        childParam="wholesalename"
                        modalModifiers={{ 'modal--chains': true }} 
                        addFacet={(facet) => this.addFacet(facet)} 
                        closeAllFacets={() => this.closeAllFacets()}
                        checkIfAnyModalIsOpen={() => this.checkIfAnyModalIsOpen()}
                        submitForm={this.props.submitForm}
                        form={this.props.form}
                        modifiers={this.numOfFacetsApplied('wholesalename') && {
                            'filters__control--is-active': true
                        }}>
                        <Chains />
                    </Facet>
                }
                {(this.props.useAssortment && this.props.search && this.props.search.facets && this.props.search.facets.filter(f => f.key === 'assortment').length > 0) &&
                    <Facet  text={this.numOfFacetsApplied('assortment') ? `Sortiment • ${this.numOfFacetsApplied('assortment')} val` : 'Sortiment'}
                            assortments={this.props.search && this.props.search.facets && this.props.search.facets.filter(f => f.key === 'assortment')}
                            modalModifiers={{ 'modal--assortment': true }} 
                            addFacet={(facet) => this.addFacet(facet)} 
                            closeAllFacets={() => this.closeAllFacets()}
                            checkIfAnyModalIsOpen={() => this.checkIfAnyModalIsOpen()}
                            submitForm={this.props.submitForm} 
                            modifiers={this.numOfFacetsApplied('assortment') && {
                                'filters__control--is-active': true
                            }}>
                        <Assortments />
                    </Facet>
                }

                {this.props.useOtherInfo &&
                    <Facet text={this.numOfFacetsApplied('otherinformation') ? `${this.numOfFacetsApplied('otherinformation')} övrig info` : 'Övrig info'} 
                            otherinformation={this.props.search && this.props.search.facets && this.props.search.facets.filter(f => f.key === 'otherinformation')}
                            modalModifiers={{ 'modal--assortment': true }} 
                            addFacet={(facet) => this.addFacet(facet)} 
                            closeAllFacets={() => this.closeAllFacets()}
                            checkIfAnyModalIsOpen={() => this.checkIfAnyModalIsOpen()}
                            submitForm={this.props.submitForm} 
                            modifiers={this.numOfFacetsApplied('assortment') && {
                                'filters__control--is-active': true
                            }}>
                        <OtherInformation />
                    </Facet>
                }
                
                <div className="filters__control">
                    <a href="/search" className="filters__clear-btn">Rensa</a>    
                </div>
            </div>
        );
    }
    
};

export default withRouter(Facets);